import type { ReactNode } from "react";
import type { Permission } from "../../../../shared/rbac/permissions";
import { Box } from "../../Box";
import { Text } from "../../Text";
import {
  DetailList,
  DetailRow,
  FieldLabel,
  HelpTooltip,
  PERMISSIONS_TOOLTIP_COPY,
} from "../shared";
import { PermissionDetails } from "./PermissionDetails";

type Props = {
  permissions: readonly Permission[];
  renderTrailing?: (permission: Permission) => ReactNode;
  onRowClick?: (permission: Permission) => void;
  isInteractive?: (permission: Permission) => boolean;
};

export function PermissionsList({
  permissions,
  renderTrailing,
  onRowClick,
  isInteractive,
}: Props) {
  return (
    <FieldLabel>
      <Box horizontal={8} vertical={10}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <Text variant="text-small-md">Permissions</Text>
          <HelpTooltip content={PERMISSIONS_TOOLTIP_COPY} />
        </div>
      </Box>
      <DetailList>
        {permissions.map((p) => (
          <DetailRow
            key={p}
            data-interactive={isInteractive?.(p) || undefined}
            onClick={onRowClick ? () => onRowClick(p) : undefined}
          >
            <PermissionDetails permission={p} />
            {renderTrailing?.(p)}
          </DetailRow>
        ))}
      </DetailList>
    </FieldLabel>
  );
}
